import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type PcsNetworkMerchantModel from './pcs-network-merchant.ts';

/** SPADE enrichment nested under `detail.merchant`. */
export interface PcsSpadeAddress {
  line1?: string;
  city?: string;
  state?: string;
  postal_code?: string;
  country?: string;
}

export interface PcsSpadeMerchant {
  name?: string;
  industry?: { names?: string[] };
  phone?: string;
  url?: string;
  logo?: string;
  location?: { address?: PcsSpadeAddress };
}

/**
 * The `detail` JSONB payload. Flat-provider rows (VISA, STRIPE) carry the
 * network fields at the top level; SPADE rows nest enriched data under
 * `merchant`. Every field is optional — each provider populates a different
 * subset, so consumers read defensively.
 */
export interface PcsNetworkMerchantDetailData {
  name?: string;
  category_code?: string;
  category?: string;
  state?: string;
  postal_code?: string;
  country?: string;
  merchant?: PcsSpadeMerchant;
}

export default class PcsNetworkMerchantDetailModel extends Model {
  @attr declare dataProvider: string;
  @attr declare terminalId: string | null;
  @attr declare detail: PcsNetworkMerchantDetailData;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('pcs-network-merchant', { async: false, inverse: 'pcsNetworkMerchantDetails' })
  declare pcsNetworkMerchant: PcsNetworkMerchantModel;

  get merchantName(): string | null {
    const detail = this.detail ?? {};
    // VISA/STRIPE store a flat `name`; SPADE nests it under `merchant`.
    return detail.name ?? detail.merchant?.name ?? null;
  }

  [Type] = 'pcs-network-merchant-detail' as const;
}
